/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Pale_Deer_ViewInputs */

const en_swift_pale_deer_view = /** @type {(inputs: Swift_Pale_Deer_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No rounds configured yet.`)
};

const de_swift_pale_deer_view = /** @type {(inputs: Swift_Pale_Deer_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Runden konfiguriert.`)
};

/**
* | output |
* | --- |
* | "No rounds configured yet." |
*
* @param {Swift_Pale_Deer_ViewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_pale_deer_view = /** @type {((inputs?: Swift_Pale_Deer_ViewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Pale_Deer_ViewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_pale_deer_view(inputs)
	return de_swift_pale_deer_view(inputs)
});